import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { TextSection } from 'polotno/side-panel';
import { StyledText } from '../common/SectionTitle';

const getColor = (theme: Theme, variant: string = 'default', selected: boolean = false) => {
    if (variant === 'border') {
        if (selected) {
            return theme.colors.primary.main;
        }

        return 'transparent';
    }

    return !selected ? theme.colors.black[100] : theme.colors.black[200];
};

const Container = styled.div`
    padding: 20px 0 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
`;

const StylesOverride = styled.div`
    max-height: calc(100% - 40px);

    // section wrapper
    > div > div:nth-child(2) {
        height: 100%;
    }

    .bp5-tabs {
        display: none;
    }

    // three buttons on top
    > div > div:nth-child(2) > button.bp5-button.bp5-minimal.polotno-close-panel {
        background-color: ${({ theme }) => theme.colors.black[100]} !important;
        margin-bottom: 8px !important;
        justify-content: flex-start;
        border-radius: 12px;
        min-height: 48px;
        padding: 14px 20px;
        position: relative;
        font-family: 'Mulish', sans-serif !important;

        :hover {
            background-color: ${({ theme }) => theme.colors.black[200]} !important;
            outline: 2px solid ${({ theme }) => theme.colors.primary.main};
            outline-offset: -3px;
        }

        span {
            display: none;
        }

        :nth-of-type(1) {
            ::before {
                content: 'Add a headline';
                font-weight: 700;
                font-size: 24px;
                line-height: 20px;
            }
        }

        :nth-of-type(2) {
            ::before {
                content: 'Add a subtitle';
                font-weight: 600;
                font-size: 20px;
                line-height: 20px;
            }
        }

        :nth-of-type(3) {
            ::before {
                content: 'Add a body';
                font-weight: 500;
                font-size: 16px;
                line-height: 20px;
            }
        }
    }

    // options container
    > div > div:nth-child(2) > div {
        margin-top: 16px;
    }

    .bp5-button + div {
        margin-top: 50px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 8px;

        > div {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        // options
        .polotno-close-panel {
            position: relative;
            width: 100%;
            height: auto;
            border-radius: 12px;
            background: ${({ theme }) => getColor(theme)};
            font-family: inherit;

            > button {
                display: none;
            }

            :hover {
                background: ${({ theme }) => getColor(theme, 'default', true)};
                outline: 2px solid ${({ theme }) => theme.colors.primary.main};
                outline-offset: -3px;
            }
        }
    }
`;

export const AddText = () => {
    const { store } = useAdvancedEditorContext();

    return (
        <Container>
            <StyledText>Add a text box</StyledText>

            <StylesOverride>
                <TextSection.Panel store={store} />
            </StylesOverride>
        </Container>
    );
};
